import { Rows } from "Components/Layout/Table";

const CreationLocationTable: Rows = {
    locationType: {
        placeholders: [
            {
                element: 'p',
                size: [2],
            }
        ],
        translated: true,
    },
    platformListing: {
        field: 'label',
        placeholders: [
            {
                element: 'p',
                size: [3],
            }
        ],
        translated: true,
    },
    routeName: {
        placeholders: [
            {
                element: 'p',
                size: [3],
            }
        ]
    },
    displayMode: {
        placeholders: [
            {
                element: 'p',
                size: [2],
            }
        ],
        translated: true,
    },
    isActive: {
        placeholders: [
            {
                element: 'p',
                size: [1],
            }
        ],
        translated: true,
    },
    actions: {
        className: 'actions',
        sortable: false,
        placeholders: [
            {
                element: 'a',
                size: 2,
            },
        ]
    },
};

export default CreationLocationTable;
